// brand-lectura-cta — light-DOM custom element that opens the hero WhatsApp
// dialog. Self-contained: no @theme/* imports. Progressive enhancement — if
// <dialog>.showModal is unsupported or JS fails, the wrapped anchor stays a
// normal link to the Lecturas collection.
if (!customElements.get('brand-lectura-cta')) {
  customElements.define(
    'brand-lectura-cta',
    class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-lectura-trigger]');
        this.dialog =
          this.closest('section')?.querySelector('[data-lectura-dialog]') ||
          document.querySelector('[data-lectura-dialog]');

        // No-JS / unsupported <dialog> → anchor keeps working as a plain link.
        if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.dialog.showModal();
        });

        // Click on backdrop (the dialog element itself) closes it.
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });

        this.dialog
          .querySelector('[data-lectura-close]')
          ?.addEventListener('click', () => this.dialog.close());

        // Esc close is native to <dialog>.
      }
    }
  );
}
